import { relationToTypesEnum } from "helpers/enums";
import SignalRConnection from "services/signalRConnection";

const documentUpdateSubscriptionTimeout = 10000;

const getRelatedToType = (item) => item.relatedToType ?? relationToTypesEnum.Bid;

export const getRelatedToId = (item) => item.relatedToId ?? item.bidId;

export const getDocumentUpdateSubscriptionKey = (item) => `${getRelatedToType(item)}:${getRelatedToId(item)}`;

export const subscribeToDocumentUpdates = ({ item, onUpdate, onClose }) => {
    const relatedToId = getRelatedToId(item);
    const relatedToType = getRelatedToType(item);

    if (relatedToId === undefined || relatedToId === null) {
        return null;
    }

    let connection;
    let closeTimer;
    let closed = false;
    const key = getDocumentUpdateSubscriptionKey(item);
    const close = () => {
        if (closed) {
            return;
        }

        closed = true;
        clearTimeout(closeTimer);
        connection?.disconnect();
        onClose?.(key);
    };

    const handleUpdate = (data) => {
        if (!data?.updateDocuments) {
            return;
        }
        if (data.id !== undefined && data.id !== null && Number(data.id) !== Number(relatedToId)) {
            return;
        }

        onUpdate?.(data);
        close();
    };

    connection = new SignalRConnection({
        url: relatedToType === relationToTypesEnum.DistributionBid ? "/signalr/distributionbids" : "/signalr/bids",
        connectionParams: String(relatedToId),
        actions: [{ name: "Update", action: handleUpdate }],
        joinActionName: "Join",
        leaveActionName: "Leave",
    });
    closeTimer = setTimeout(close, documentUpdateSubscriptionTimeout);

    return { key, close };
};
